import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import qs from 'query-string';
import _get from 'lodash/get';
import _omit from 'lodash/omit';

// UI
import ClearableSearch from 'components/Form/ClearableSearch';

// Component
class TableSearchTextField extends PureComponent {
  static propTypes = {
    history: PropTypes.object.isRequired,
    hintText: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const { history } = props;
    const query = qs.parse(history.location.search);

    this.state = {
      value: _get(query, 'q', ''),
    };
  }

  handleSearch = (searchQuery = '') => {
    const { history } = this.props;
    const query = qs.parse(history.location.search);

    if (searchQuery) {
      query.q = searchQuery;
      delete query.page;
    } else {
      delete query.q;
    }

    history.push(`${history.location.pathname}?${qs.stringify(query)}`);
  };

  handleClearSearch = () => {
    const { history } = this.props;
    const query = _omit(qs.parse(history.location.search), 'q');
    history.push(`${history.location.pathname}?${qs.stringify(query)}`);
  };

  render() {
    const { hintText } = this.props;

    return (
      <ClearableSearch
        placeholder={hintText}
        onSearch={this.handleSearch}
        onClear={this.handleClearSearch}
      />
    );
  }
}

export default withRouter(TableSearchTextField);
